import React from "react";
import { Collapse, List, makeStyles } from "@material-ui/core";
import PlatformSidebarCategory from "./PlatformSidebarCategory";
import PlatformSidebarLink from "./PlatformSidebarLink";
import { menuItems } from "../../routes";
import useExpandedCategories from "../../hooks/useExpandedCategories";
import useIsMobile from "../../hooks/useIsMobile";

const useStyles = makeStyles((theme) => ({
  navigationContainer: {
    flexGrow: 1,
    overflowY: "auto",
  },
  divider: {
    background: "rgba(255, 255, 255, 0.12)",
  },
}));

function PlatformDrawerMenuItems() {
  const classes = useStyles();
  const { expandedCategories, toggleCategory } = useExpandedCategories();

  return (
    <div className={classes.navigationContainer}>
      <List disablePadding>
        <div>
          {menuItems?.map((menuItem, index) => (
            <React.Fragment key={index}>
              {menuItem.children ? (
                <React.Fragment key={index}>
                  <PlatformSidebarCategory
                    isOpen={expandedCategories.includes(index)}
                    isCollapsable
                    name={menuItem.label}
                    icon={menuItem.icon}
                    button
                    disableRipple
                    onClick={() => toggleCategory(index)}
                  />
                  <Collapse
                    in={expandedCategories.includes(index)}
                    timeout="auto"
                    unmountOnExit
                  >
                    {menuItem.children.map((route, subIndex) => (
                      <PlatformSidebarLink
                        key={subIndex}
                        name={route.label}
                        to={menuItem.path + route.path}
                        icon={route.icon}
                      />
                    ))}
                  </Collapse>
                </React.Fragment>
              ) : (
                <PlatformSidebarLink
                  name={menuItem.label}
                  to={menuItem.path}
                  icon={menuItem.icon}
                />
              )}
            </React.Fragment>
          ))}
        
        </div>
      </List>
    </div>
  );
}

export default PlatformDrawerMenuItems;
